import { type UseQueryResult, useQuery } from 'react-query';
import {
  AllowedRoleMappingService,
  PagedResultDto_AllowedRoleMappingsVm,
} from '../../services/wealthlane-customer-services';
import { TableParamsType } from '../../types/common';

const useGetAllowedRoleMapping = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType
): UseQueryResult<PagedResultDto_AllowedRoleMappingsVm | undefined, unknown> => {
  const { filter, sorting, skipCount, maxResultCount } = tableInfo;
  return useQuery(
    ['getAllowedRoleMappings', filter, sorting, skipCount, maxResultCount],
    async () => {
      return await handleRequest(
        AllowedRoleMappingService.getApiCustomerApiCustomerSuccessAllowedRoleMapping(
          '',
          '',
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );
};

export default useGetAllowedRoleMapping;
